























import { Vue, Component, Prop } from 'vue-property-decorator';
import vSelect from 'vue-select';

@Component({
  components: {
    vSelect,
  },
})
export default class Dropdown extends Vue {
  @Prop({ default: () => [] }) options: any[];
  @Prop({ default: false }) disabled: boolean;
  @Prop() label: string;
  @Prop() listLabel: string;
  @Prop() value: any;
  @Prop({ default: true }) searchable: boolean;
  @Prop() placeholder: string;
  @Prop({ default: false }) clearable: boolean;
  @Prop() dark: boolean;
  @Prop() index: string;
  @Prop({ default: false }) required: boolean;

  handleInput(value: string) {
    this.$emit('input', value);
  }

  handleFocus(event: any) {
    this.$emit('focus', event);
  }

  handleBlur(event: any) {
    this.$emit('blur', event);
  }
}
